/** @jsxImportSource react */
import { RouteObject } from "react-router-dom";
import HomePage from '@/pages/home/page';
import AboutPage from '@/pages/about/page';
import ServicesPage from '@/pages/services/page';
import CoveragePage from '@/pages/coverage/page';
import ContactPage from '@/pages/contact/page';
import PaymentPage from '@/pages/payment/page';
import DebtPage from '@/pages/debt/page';
import LecturacionPage from '@/pages/lecturacion/page';
import ReclamosPage from '@/pages/reclamos/page';
import TerminosPage from '@/pages/terminos/page';
import PrivacidadPage from '@/pages/privacidad/page';
import NormativaPage from '@/pages/normativa/page';

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/nosotros",
    element: <AboutPage />,
  },
  {
    path: "/servicios",
    element: <ServicesPage />,
  },
  {
    path: "/cobertura",
    element: <CoveragePage />,
  },
  {
    path: "/contacto",
    element: <ContactPage />,
  },
  {
    path: "/pagar",
    element: <PaymentPage />,
  },
  {
    path: "/consultar-deuda",
    element: <DebtPage />,
  },
  {
    path: "/lecturacion",
    element: <LecturacionPage />,
  },
  {
    path: "/reclamos",
    element: <ReclamosPage />,
  },
  {
    path: "/terminos",
    element: <TerminosPage />,
  },
  {
    path: "/privacidad",
    element: <PrivacidadPage />,
  },
  {
    path: "/normativa",
    element: <NormativaPage />,
  },
];

export default routes;